module.exports = __webpack_public_path__ + "img/empty.40bbeec8.png";